import {
  Box,
  Button,
  Container,
  Heading,
  HStack,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaStamp } from "react-icons/fa6";
import { TiMediaPlayOutline } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Logo from "../../../assets/colorLogo.png";
import PublicLayout from "../../../components/public/Layout/layout";
import Layout from "../../../components/student/Layout/layout";
import ChooseGroup from "../../../containers/student/models/choose-group";
import { openChooseStudentGroup } from "../../../modules/admin-modules/models/Actions";
import {
  getTeacherCoursesRequest,
  getTeacherRequest,
} from "../../../modules/public/publicData/Actions";

const TeacherDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { teacher } = useSelector((state) => state.public);
  const { teacherCourses } = useSelector((state) => state.public);
  const userData = useSelector((state) => state.user.userData);
  const [selectedData, setSelectedData] = useState(null);

  useEffect(() => {
    dispatch(getTeacherRequest(id));
    dispatch(getTeacherCoursesRequest(id, userData?.id));
  }, [id, userData?.id]);

  const subjects = teacher?.subjects?.map((val) => val?.name)?.join(",");

  const handelNavigate = (data) => {
    if (data?.is_enrolled == "Enrolled")
      navigate(`/teacher/${data?.id}/courses`);
  };
  const baseUrl = "https://api.agwad.net/";

  const DisplayedLayout = userData?.id ? Layout : PublicLayout;
  return (
    <DisplayedLayout color={userData?.id ? "main_1" : "white"} bg="main_1">
      <Container
        maxW="container.xl"
        py={36}
        gap={12}
        display="flex"
        flexDirection="column"
      >
        <Box h="400px" bg="#010038bf" position="relative">
          <Box
            position="absolute"
            backgroundPosition="center "
            backgroundSize="contain"
            backgroundRepeat="no-repeat"
            zIndex={-1}
            w="100%"
            h="100%"
            bgImage={
              teacher?.profile_picture
                ? `${baseUrl}${teacher?.profile_picture}`
                : Logo
            }
          ></Box>

          <Stack p={7} justifyContent="center" h="100%" gap={2}>
            <Image
              src={
                teacher?.profile_picture
                  ? `${baseUrl}${teacher?.profile_picture}`
                  : Logo
              }
              alt="Green double couch with wooden legs"
              w="100px"
              h="100px"
              borderRadius="50%"
            />
            <Heading as="h1" fontWeight="700" color="white" lineHeight={1.4}>
              {teacher?.name}
            </Heading>
            <Text color="white" fontSize="14px">
              {subjects}
            </Text>
            <HStack color="white" gap={5}>
              <HStack>
                <FaStamp size={20} />{" "}
                <p>
                  {teacherCourses?.map((val) => val?.name)?.join(", ")}
                </p>
              </HStack>
              <HStack>
                <TiMediaPlayOutline size={28} />{""}
                <p>{teacherCourses?.length} Courses</p>
              </HStack>
            </HStack>
          </Stack>
        </Box>

        <Stack>
          <Text fontWeight="600">Description</Text>
          <p>{teacher?.bio} </p>
        </Stack>

        <HStack flexWrap="wrap" gap={4}>
          {teacherCourses?.map((data) => {
            return (
              <Box
                bg="gray.100"
                w="200px"
                h="200px"
                borderRadius="16px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
                color="#4A5568"
                cursor="pointer"
                _hover={{
                  color: "main_1",
                }}
                gap={8}
                onClick={() => handelNavigate(data)}
              >
                <FaStamp size={50} />
                <Text fontSize="20px" fontWeight={600}>
                  {data?.name}
                </Text>
                {data?.is_enrolled == "Not Enrolled" && (
                  <Button
                    bg="main_1"
                    color="white"
                    onClick={() => {
                      if (!userData?.id) toast.error("Please Login first ");
                      else {
                        dispatch(openChooseStudentGroup());
                        setSelectedData(data);
                      }
                    }}
                  >
                    Enroll
                  </Button>
                )}

                {data?.is_enrolled == "Pending" && <Text>Pending</Text>}
              </Box>
            );
          })}
        </HStack>
      </Container>
      <ChooseGroup selectedData={selectedData} />
    </DisplayedLayout>
  );
};

export default TeacherDetails;
